import React from "react";
import { Link } from "react-router-dom";

const footerItems = [
  { itemName: "Datenschutz & AGBS", link: "/terms" },
  { itemName: "Impressum", link: "/impressum" },
  { itemName: "Kontakt", link: "/contact" },
  { itemName: "Unsere Leistungen", link: "/service" },
];
const Product = [
  {
    itemName: "Works",
    link: "/",
  },
  {
    itemName: "About",
    link: "/",
  },
  {
    itemName: "News",
    link: "/",
  },
  {
    itemName: "Contact",
    link: "/",
  },
];

const Footer = () => {
  return (
    <div className="row">
      <div className="col-12 col-xl-6">
        {/* <!--Animated Block--> */}
        <div className="ptf-animated-block" data-aos="fade" data-aos-delay="0">
          <div
            className="ptf-footer-heading has-black-color"
            style={{ maxWidth: "37.5rem" }}
          >
            Alle guten Dinge
          </div>

          <div className="ptf-footer-heading has-black-color">
            Starten mit
            <Link style={{marginLeft: "10px"}}
              className="has-accent-1 text-decoration-underline"
              to="/contact"
            >
              einem Hi!
            </Link>
          </div>

          <p className="fz-24">Im Unteren Feld 59, 73277 Owen Deutschland</p>
          <a className="fz-40 has-black-color" href="mailto:mail@one-digitalify.com">
              mail@one-digitalify.com
          </a>
        </div>
      </div>
      <div className="col-12 col-md-6 col-xl-3">
        {/* <!--Animated Block--> */}
        <div
          className="ptf-animated-block"
          data-aos="fade"
          data-aos-delay="100"
        >
          <div className="ptf-widget ptf-widget-links has-black-color">
            <h4 className="ptf-widget-title">Links</h4>
            <ul>
              {footerItems.map((val, i) => (
                <li key={i}>
                  <a href={val.link}>{val.itemName}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 col-xl-3">
        {/* <!--Animated Block--> */}
        <div
          className="ptf-animated-block"
          data-aos="fade"
          data-aos-delay="200"
        >
          {/* <div className="ptf-widget ptf-widget-text">
            <h4 className="ptf-widget-title">Product</h4>
            <div className="ptf-widget ptf-widget-links has-black-color">
              <ul>
                {Product.map((val, i) => (
                  <li key={i}>
                    <a href={val.link}>{val.itemName}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
